(function () {
    'use strict';

    angular.module('PublicApp', [
        'ngMessages',
        'ngAnimate',
        'ngSanitize',
        'ui.router',
        'ngNotify',
        'ngDialog',
        'angular-loading-bar',
        'selectize',
        'lw.core.utils',
        'lw.security.main',
        'lw.auth',
        'rzModule',
        'lw.data.datastore',
        'lw.data.datatable',
        'NgSwitchery',
        'lw.form.main',
        'app.service',
        'app.http',
        'app.notification',
        'app.form',
        'app.directives',
        'PublicApp.master',
        'UserApp.login',
        'UserApp.logout',
        'UserApp.forgotPassword',
        'UserApp.resendActivationEmail',
        'UserApp.resetPassword',
        'UserApp.changePassword',
        'UserApp.changeEmail',
        'UserApp.register',
        'UserApp.contact',
        'UserApp.profile',
        'UserApp.profileEdit',
        'UserApp.address',
        'UserApp.Addresslist',
        'UserApp.editAddress',
        'PublicApp.display.products',
        'PublicApp.display.featured.products',
        'PublicApp.productDetails',
        'ManageProductApp.allProductReviews',
        'ManageProductApp.allProductQuestions',
        'PublicApp.productDetailsDialog',
        'PublicApp.page.details',
        'PublicApp.ShoppingCart.cart',
        'PublicApp.ShoppingCart.orderSummary',
        'PublicApp.Order.list',
        'PublicApp.Order.details',
        'PublicApp.Order.cancel',
        'PublicApp.Order.log',
        'PublicApp.address',
        'PublicApp.myWishList',
        'PublicApp.myRatingList'
    ]).
        //constant('__ngSupport', window.__ngSupport).
        run([
            '__Auth', '$state', '$rootScope', function (__Auth, $state, $rootScope) {

                // Verify Route Permissions
                __Auth.verifyRoute($state);

                $rootScope.__ngSupport = window.__ngSupport;

            }
        ]).
        config([
            '$stateProvider', '$urlRouterProvider', '$interpolateProvider', routes
        ]);


    /**
      * Application Routes Configuration
      *
      * @inject $stateProvider
      * @inject $urlRouterProvider
      * @inject $interpolateProvider
      *
      * @return void
      *---------------------------------------------------------------- */

    function routes($stateProvider, $urlRouterProvider, $interpolateProvider) {

        $interpolateProvider.startSymbol('[[');
        $interpolateProvider.endSymbol(']]');

    };

})();